import { makeStyles, Theme } from '@material-ui/core/styles';

export const DASHBOARD_COLORS = {
  background: '#f7f8fc',
  card: '#ffffff',
  border: 'rgba(46, 98, 255, 0.3)',
  rowDivider: '#e7eaf8',
  rowHover: '#f7f8fc',
  neutral100: '#e7eaf8',
  neutral800: '#34395e',
  muted: '#5e69a6',
  foreground: '#000007',
  destructive: '#ff2e5b',
  chart: ['#3b82f6', '#22c55e', '#fbbf24', '#d946ef'],
};

export const useStatusDashboardStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    flex: 1,
    minHeight: '100%',
    background: DASHBOARD_COLORS.background,
    color: DASHBOARD_COLORS.foreground,
  },
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '28px 24px 64px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  card: {
    borderRadius: 24,
    boxShadow: '-4px 4px 8px 0 rgba(52, 57, 94, 0.08)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
  cardTitle: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
  },
  muted: {
    fontSize: 12,
    color: DASHBOARD_COLORS.muted,
  },
  mutedSmall: {
    fontSize: 11,
    color: DASHBOARD_COLORS.muted,
  },
  overline: {
    fontSize: 11,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    color: DASHBOARD_COLORS.muted,
  },
  tile: {
    border: `1px solid ${DASHBOARD_COLORS.border}`,
    borderRadius: 16,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  tileValue: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.1,
    fontVariantNumeric: 'tabular-nums',
  },
  tableHead: {
    display: 'grid',
    gap: 8,
    padding: '0 12px 8px',
    borderBottom: `1px solid ${DASHBOARD_COLORS.border}`,
    fontSize: 11,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    color: DASHBOARD_COLORS.muted,
  },
  tableRow: {
    display: 'grid',
    gap: 8,
    alignItems: 'center',
    padding: '14px 12px',
    borderBottom: `1px solid ${DASHBOARD_COLORS.rowDivider}`,
    fontSize: 13,
  },
  sortableHeader: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 4,
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      color: DASHBOARD_COLORS.foreground,
    },
  },
  sortableHeaderLeft: {
    justifyContent: 'flex-start',
  },
  sortableHeaderActive: {
    color: DASHBOARD_COLORS.foreground,
  },
  sortArrow: {
    fontSize: 14,
  },
  filterRow: {
    display: 'grid',
    gap: 8,
    padding: '8px 12px',
    borderBottom: `1px solid ${DASHBOARD_COLORS.border}`,
  },
  columnFilter: {
    width: 'calc(100% - 16px)',
    minWidth: 0,
    height: 28,
    padding: '0 8px',
    fontSize: 13,
    fontFamily: 'inherit',
    border: `1px solid ${DASHBOARD_COLORS.border}`,
    borderRadius: 4,
    background: '#fff',
    outline: 'none',
    '&:focus': {
      borderColor: DASHBOARD_COLORS.muted,
    },
  },
  paginationBar: {
    border: 'none',
    background: 'transparent',
    padding: '12px 0 0',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      background: DASHBOARD_COLORS.rowHover,
    },
  },
  right: {
    textAlign: 'right',
  },
  number: {
    fontVariantNumeric: 'tabular-nums',
  },
  bold: {
    fontWeight: 700,
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  [theme.breakpoints.down('sm')]: {
    container: {
      padding: '16px 0 32px',
    },
  },
}));
